var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"/logo-small.png","alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }